export const displayFontFamily = `'Ostitich Sans', 'sans-serif'`;
export const bodyFontFamily = `'Gotham', 'sans-serif'`;
export const bodyThinFontFamily = `'Gotham Thin', 'sans-serif'`;
